import { render, staticRenderFns } from "./contents.vue?vue&type=template&id=e32be7b2&scoped=true&"
import script from "./contents.vue?vue&type=script&lang=js&"
export * from "./contents.vue?vue&type=script&lang=js&"
import style0 from "./contents.vue?vue&type=style&index=0&id=e32be7b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32be7b2",
  null
  
)

export default component.exports